import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '../src/assets/less/global.less'
import './plugins/element.js'
import dataV from '@jiaminghi/data-view'
import G2 from '@antv/g2'
import '../src/assets/less/clock.less'
import Http from './utils/http'
import md5 from 'js-md5';
import axios from 'axios';
import BaiduMap from 'vue-baidu-map';
import TreeTable from 'vue-table-with-tree-grid'
import Vue2OrgTree from 'vue2-org-tree';
import OSS from 'ali-oss';

//import VueSession from 'vue-session'
Vue.use(Http)
//Vue.use(OSS)
Vue.config.productionTip = false
Vue.use(dataV)
Vue.use(G2)
Vue.use(Vue2OrgTree)
Vue.component('tree-table', TreeTable)

Vue.prototype.$md5 = md5;
Vue.prototype.$axios=axios;
Vue.use(BaiduMap,{
  ak:'7a5GRsj4Br7ZvNLXZVh4LLqn'
})
//Vue.use(VueSession)
console.log(1);
router.beforeEach((to, from, next) => {
  var token = sessionStorage.getItem('token'); 
  var issys = parseInt(sessionStorage.getItem('issys')); 
  var type = parseInt(sessionStorage.getItem("usertype"));
  window.console.log(token);
  if (to.path.startsWith('/login')) {
    if(token == '' || token == undefined){
      next()
    }else{
      next({
        path: '/welcome',
      })
    }
  }else if(token == '' || token == undefined){
    next({
      path: '/login',
    })
  }else{
    if(issys == 1){
      next();
    }else{
      next()
    }
  }
})

// 判断是否需要登录权限 以及是否登录
/*
router.beforeEach((to, from, next) => {
  var token = this.$session.get("token"); 
  console.log(token);
  if(token == '' || token == undefined){
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }else{
    var type = parseInt(this.$session.get("usertype"));
    if(type != 1){
      next({
        path: '/index',
        query: { redirect: to.fullPath }
      })
    }else{
      next()
    }
  }
})
*/



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
